import React from 'react';
import { useSelector } from '@xstate/react';
import { Modal } from '@chargify/custom-ui-components';
import { useDeviceInfo } from '@chargify/device-provider';

import { useServices } from '../../hooks';
import { modalsSelectors } from '../../machines';
import Content from './Content';

const ChangePaymentMethod = () => {
  const { modalsService } = useServices();
  const { device } = useDeviceInfo();

  const { isOpen, meta } = useSelector(
    modalsService,
    modalsSelectors.getChangePaymentMethod
  );
  const closeHandler = () => {
    modalsService.send({ type: 'CLOSE_MODAL' });
  };
  const modalVariant = device === 'mobile' ? 'layer' : 'window';
  return (
    <Modal
      isOpen={isOpen}
      onClose={closeHandler}
      variant={modalVariant}
      width="100%"
    >
      <Content {...meta} displayMode={'window'} onClose={closeHandler} />
    </Modal>
  );
};

export default ChangePaymentMethod;
